import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDestinations = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#destinations_svg__a)">
      <path
        fill="#263E6A"
        d="M12.426 12.103c-1.71 0-3.102-1.373-3.102-3.061s1.391-3.061 3.102-3.061 3.101 1.373 3.101 3.06q0 .158-.016.314a.284.284 0 0 1-.566-.059q.013-.127.013-.254c0-1.375-1.136-2.493-2.532-2.493S9.893 7.667 9.893 9.042s1.136 2.492 2.533 2.492c.44 0 .872-.113 1.252-.325a.285.285 0 0 1 .278.496c-.464.26-.993.398-1.53.398m.177 8.59 4.094-7.944c.107-.207.284-.546.394-.752.031-.058.76-1.44.76-2.634C17.851 6.406 15.417 4 12.426 4 9.433 4 7 6.406 7 9.363c0 1.2.729 2.577.76 2.635.108.203.274.538.369.748l3.591 7.924c.093.205.251.325.434.33h.01c.179 0 .338-.111.44-.308m4.68-11.33c0 1.05-.687 2.354-.694 2.367-.11.208-.29.55-.398.759l-4.02 7.8-3.524-7.778c-.1-.219-.272-.57-.386-.781-.007-.013-.692-1.308-.692-2.367 0-2.643 2.178-4.794 4.857-4.794 2.678 0 4.856 2.15 4.856 4.794"
      />
    </g>
    <defs>
      <clipPath id="destinations_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDestinations;
